import { BRAND_OWNER_DELIMITER } from '../../common/brandOwner.constants';
import { formatSharedBrandsLabel } from '../../common/brandOwner.utils';
import { DynamicTitle, TitleSelector } from '../../types';

/**
 * Formats the heading title for export, particularly for values brand owner delimiters.
 * Checks if the MenuItems contain brand owner delimiters and formats their labels accordingly.
 * @param headingTitle the heading title which can be a string or a dynamic title
 * @param sharedBrands list of shared brands
 * @returns heading title object with the formatted labels
 */
export const getExportHeadingTitle = (headingTitle: string | DynamicTitle, sharedBrands: string[]) => {
  if (!headingTitle || typeof headingTitle === 'string') {
    return headingTitle;
  }
  const clonedHeadingTitle = structuredClone(headingTitle);
  const titleWithParamNames = clonedHeadingTitle.filter(
    title => !!(title as TitleSelector).menu?.paramName
  )?.[0] as TitleSelector;
  if (!titleWithParamNames) {
    return clonedHeadingTitle;
  }
  titleWithParamNames.menu.items.forEach(item => {
    if (item.type === 'MenuItem' && typeof item.value === 'string') {
      item.label = item.value.includes(BRAND_OWNER_DELIMITER)
        ? formatSharedBrandsLabel(item, sharedBrands)
        : item.label;
    }
  });
  return clonedHeadingTitle;
};

export const mapKeyIndicatorsForExport = (exportSlides: Element[]): Element[] => {
  if (exportSlides.length >= 2) {
    const firstSlide = exportSlides[0] as HTMLDivElement;
    const secondSlide = exportSlides[1] as HTMLDivElement;
    if (firstSlide.children.length === 1) {
      const loneChild = firstSlide.children[0] as HTMLElement;
      secondSlide.insertBefore(loneChild, secondSlide.firstChild);
      firstSlide.parentElement?.removeChild(firstSlide);
      return exportSlides.slice(1);
    }
  }
  return exportSlides;
};
